import { render, staticRenderFns } from "./OnSiteConfirmationMailing.vue?vue&type=template&id=01acfee4&scoped=true&"
import script from "./OnSiteConfirmationMailing.vue?vue&type=script&lang=js&"
export * from "./OnSiteConfirmationMailing.vue?vue&type=script&lang=js&"
import style0 from "./OnSiteConfirmationMailing.vue?vue&type=style&index=0&id=01acfee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01acfee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow,VTextField})
